import React from "react";
import Title from "../../layout/Title";
import {t} from "../../i18n";
import { ReactNode } from "react-markdown";

interface Props {
    type: string
}

type AllProps = Props;

export class SimplepayPaymentComponent extends React.Component<AllProps, any> {
    constructor(props:AllProps) {
        super(props);
    }

    renderWithdraw() {
        return(
            <div className="withdraw-title">
                <Title animate={true} title={ `${t("withdraw.provider.simplepay.title")}`}/>
            </div>
        )
    }

    renderDeposit() {
        return(
            <div>Deposit</div>
        )
    }

    render(): ReactNode | ReactNode[] {
        if(this.props.type == "withdraw") {
            return this.renderWithdraw()
        }
        if(this.props.type == "deposit") {
            return  this.renderDeposit()
        }
    }
}